import type { FC, ReactNode } from 'react'

import { Reveal } from '@/components/generals/reveal'
import { SectionLabel } from '@/components/generals/section-label'
import { services } from '@/constants/content'

export const Services: FC = (): ReactNode => {
    return (
        <section id='services' data-surface='ink' className='bg-foreground py-20 text-background md:py-32'>
            <div className='page-container'>
                <div className='grid gap-8 md:grid-cols-12 md:items-end'>
                    <div className='md:col-span-8'>
                        <SectionLabel className='text-background/60' markClassName='text-brand-light'>
                            Services
                        </SectionLabel>

                        <h2 className='mt-5 text-balance font-heading text-[clamp(2.75rem,7vw,6.75rem)] font-semibold leading-[0.9] tracking-[-0.045em]'>
                            Everything your site needs, <em className='font-serif font-normal italic tracking-[-0.02em] text-brand-light'>nothing</em> it doesn't.
                        </h2>
                    </div>

                    <p className='max-w-sm text-lg leading-relaxed text-background/65 md:col-span-4 md:justify-self-end'>
                        One designer from strategy to launch, so nothing gets lost between the idea, the mockup and the live site.
                    </p>
                </div>

                <ul className='mt-14 border-b border-background/15 md:mt-20'>
                    {services.map((service, index) => (
                        <li key={service.title} className='group border-t border-background/15'>
                            <Reveal className='grid gap-4 py-8 md:grid-cols-12 md:items-baseline md:gap-8 md:py-11'>
                                <span className='font-mono text-xs font-medium text-background/45 md:col-span-1'>
                                    {String(index + 1).padStart(2, '0')}
                                </span>

                                <h3 className='font-heading text-3xl font-semibold tracking-[-0.035em] transition-[color,transform] duration-500 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:translate-x-2 group-hover:text-brand-light md:col-span-5 md:text-5xl'>
                                    {service.title}
                                </h3>

                                <div className='md:col-span-6'>
                                    <p className='max-w-xl text-lg leading-relaxed text-background/70'>
                                        {service.description}
                                    </p>

                                    <ul className='mt-5 flex flex-wrap gap-2'>
                                        {service.deliverables.map(item => (
                                            <li key={item} className='rounded-full border border-background/20 px-3.5 py-1.5 text-sm text-background/80'>
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </Reveal>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    )
}
